import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <>
      <SEO title="Terms of Service" description="Read the terms and conditions for using TopInfo Rwanda marketplace. Rules for buyers, sellers, and service providers." keywords="terms of service TopInfo Rwanda, terms conditions marketplace, user agreement Rwanda" />
      <div className="min-h-screen bg-gray-50/50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
          <p className="text-sm text-gray-400 mb-8">Last updated: January 2025</p>

          <div className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-8 space-y-6 text-gray-600 text-sm leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">1. Acceptance of Terms</h2>
              <p>By accessing and using TopInfo Rwanda (topinfo.rw), you agree to be bound by these Terms of Service. If you do not agree, please do not use our platform.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">2. Platform Description</h2>
              <p>TopInfo Rwanda is an online marketplace connecting service providers, product sellers, and buyers across Rwanda. We provide the platform for listings, bookings, and communication between users.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">3. User Accounts</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>You must provide accurate and complete information when creating an account.</li>
                <li>You are responsible for maintaining the security of your account credentials.</li>
                <li>You must be at least 18 years old to create an account.</li>
                <li>One person may not maintain more than one account.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">4. Listings & Content</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>You are solely responsible for the content you post on TopInfo.</li>
                <li>Listings must be accurate, honest, and not misleading.</li>
                <li>Prohibited content includes: illegal items, counterfeit goods, harmful substances, weapons, and adult content.</li>
                <li>We reserve the right to remove any listing that violates these terms.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">5. Transactions</h2>
              <p>TopInfo facilitates connections between buyers and sellers. All transactions, payments, and delivery arrangements are between the buyer and seller. TopInfo is not a party to these transactions and is not responsible for the quality, safety, or legality of items listed.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">6. Reviews & Ratings</h2>
              <p>Reviews must be honest and based on genuine experiences. We may remove reviews that are fraudulent, abusive, or violate community guidelines.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">7. Prohibited Activities</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>Spamming or posting duplicate listings.</li>
                <li>Harassing other users.</li>
                <li>Attempting to circumvent platform fees or rules.</li>
                <li>Using automated tools to scrape or collect data.</li>
                <li>Impersonating other users or entities.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">8. Account Termination</h2>
              <p>We may suspend or terminate accounts that violate these terms, engage in fraudulent activity, or harm the platform community.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">9. Limitation of Liability</h2>
              <p>TopInfo Rwanda is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the platform or transactions with other users.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">10. Contact</h2>
              <p>For questions about these terms, contact us at <a href="mailto:info@topinfo.rw" className="text-primary-600 hover:underline">info@topinfo.rw</a>.</p>
            </section>
          </div>

          <div className="mt-8 text-center">
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm font-medium">&larr; Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPage;
